import {formatMass} from "./formatMass";

export function formatLiftMass(liftMassKg) {
    return formatMass(liftMassKg, liftMassUnit);
}
